import axios from 'axios';
import store from '../vuex/store'
import Vue from 'vue';
import routes from '../routes'
import router from '../router'
import { Notification, MessageBox, Message, Loading } from 'element-ui'

// 创建 Axios 实例
const service = axios.create({
  //baseURL: '/prod-api/', //本地
  baseURL: 'https://api.unishow.live/', //线上
  timeout: 10000, // 请求超时时间
  withCredentials: true
});
// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 在发送请求之前做些什么，例如添加 token
    const token = store.state.token;
	const language = store.state.language;
    if (token) {
      config.headers['unishow_api_token'] = token;
    }
	config.headers['language'] = language?language:'taiwan'
	// config.headers['equipment_type'] = 4;
    return config;
  },
  (error) => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 响应拦截器
service.interceptors.response.use(
  function (response) {
    // 对响应数据做些什么
    const res = response.data;
	console.log(res,123)
	if (res.code == 200) {
	  return res;
	}else if (res.code == 500) {
      // 处理业务错误
      Message({ message: res.msg, type: 'error' })
	  return Promise.reject(res); // 抛出业务错误
    }else if (res.code == 401) {
      // 处理业务错误
      Message({ message: res.msg, type: 'error' })
	  // router.push('/login');
	  setTimeout(v=>{
		sessionStorage.setItem('user', 1);
		window.location.href = '#/login'; 
	  },1000)
	  return Promise.reject(res); // 抛出业务错误
    } else {
      Message({ message: res.msg, type: 'error' })
	  return Promise.reject(res); // 抛出业务错误
    }
  }.bind(new Vue()),
  (error) => {
    // 对响应错误做些什么
    return Promise.reject(error);
  }
);

export default service;


// WEBPACK FOOTER //
// ./src/utils/request.js